function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.957 15.5859C23.1306 15.5859 24.082 14.6345 24.082 13.4609C24.082 12.2873 23.1306 11.3359 21.957 11.3359C20.7834 11.3359 19.832 12.2873 19.832 13.4609C19.832 14.6345 20.7834 15.5859 21.957 15.5859Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.043 15.5859C13.2166 15.5859 14.168 14.6345 14.168 13.4609C14.168 12.2873 13.2166 11.3359 12.043 11.3359C10.8694 11.3359 9.91797 12.2873 9.91797 13.4609C9.91797 14.6345 10.8694 15.5859 12.043 15.5859Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9987 19.8359C13.6979 19.8359 10.8787 21.8901 9.74536 24.7943H12.1112C13.0887 23.1084 14.902 21.9609 16.9987 21.9609C19.0954 21.9609 20.8945 23.1084 21.8862 24.7943H24.252C23.1187 21.8901 20.2995 19.8359 16.9987 19.8359ZM16.9845 2.83594C9.16453 2.83594 2.83203 9.1826 2.83203 17.0026C2.83203 24.8226 9.16453 31.1693 16.9845 31.1693C24.8187 31.1693 31.1654 24.8226 31.1654 17.0026C31.1654 9.1826 24.8187 2.83594 16.9845 2.83594ZM16.9987 28.3359C10.737 28.3359 5.66536 23.2643 5.66536 17.0026C5.66536 10.7409 10.737 5.66927 16.9987 5.66927C23.2604 5.66927 28.332 10.7409 28.332 17.0026C28.332 23.2643 23.2604 28.3359 16.9987 28.3359Z"
});

function SvgSentimentDissatisfied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentDissatisfied);
export default __webpack_public_path__ + "static/media/sentimentDissatisfied.17563450.svg";
export { ForwardRef as ReactComponent };